<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Atharva Patwardhan was born in Middlesbrough, England, in 2002. At the age of seven, he emigrated up to Scotland with his family. He completed his first novel, <em>Katmeridou</em>, at eighteen years old.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?5f70883a